const SELECT_USER = "SELECT_USER"
const ADD_ROLE = "ADD_ROLE"
const REMOVE_ROLE = "REMOVE_ROLE"
const SEARCH_USERS = "SEARCH_USERS"
const SEARCHING_USERS = "SEARCHING_USERS"
const SEARCH_ABORT = "SEARCH_ABORT"
const SEARCH_ABORTED = "SEARCH_ABORTED"
const SEARCH_FAILED = "SEARCH_FAILED"
const SEARCH_DONE = "SEARCH_DONE"
const SAVING_USER = "SAVING_USER"
const SAVING_USER_ABORTED = "SAVING_USER_ABORTED"
const SAVE_USER = "SAVE_USER"
const USER_SAVED = "USER_SAVED"
const SET_USER_PROPERTY = "SET_USER_PROPERTY"

export {
    ADD_ROLE,
    REMOVE_ROLE,
    SAVE_USER,
    SAVING_USER,
    SAVING_USER_ABORTED,
    SEARCH_ABORT,
    SEARCH_ABORTED,
    SEARCH_DONE,
    SEARCH_FAILED,
    SEARCH_USERS,
    SEARCHING_USERS,
    SELECT_USER,
    SET_USER_PROPERTY,
    USER_SAVED,
}
